import { createTheme, alpha } from "@mui/material/styles";

// Brand palette
const BRAND = {
  primary: "#EE295D",
  primaryDark: "#d71d4f",
  primaryLight: "#f25e83",

  // Neutral indigo-gray carried over from the Argon dashboard
  secondary: "#32325d",
  secondaryLight: "#525f7f",

  // Semantic
  success: "#2dce89",
  info: "#11cdef",
  warning: "#fb6340",
  error: "#f5365c",

  // Neutrals
  gray: "#8898aa",
  grayDark: "#32325d",
  grayLight: "#adb5bd",
  border: "#dee2e6",
  backgroundDefault: "#ffffff",
  backgroundPaper: "#ffffff",

  textPrimary: "#333333",
  textSecondary: "#8898aa",

  white: "#ffffff",
};

const FONT_FAMILY = "'Averta-Light', sans-serif";

// Theme
const theme = createTheme({
  // Palette
  palette: {
    mode: "light",
    primary: {
      main: BRAND.primary,
      dark: BRAND.primaryDark,
      light: BRAND.primaryLight,
      contrastText: BRAND.white,
      50: alpha(BRAND.primary, 0.08),
    },
    secondary: {
      main: BRAND.secondary,
      light: BRAND.secondaryLight,
      contrastText: BRAND.white,
    },
    success: {
      main: BRAND.success,
      contrastText: BRAND.white,
    },
    info: {
      main: BRAND.info,
      contrastText: BRAND.white,
    },
    warning: {
      main: BRAND.warning,
      contrastText: BRAND.white,
    },
    error: {
      main: BRAND.error,
      contrastText: BRAND.white,
    },
    text: {
      primary: BRAND.textPrimary,
      secondary: BRAND.textSecondary,
      disabled: BRAND.grayLight,
    },
    divider: BRAND.border,
    background: {
      default: BRAND.backgroundDefault,
      paper: BRAND.backgroundPaper,
    },
    action: {
      hover: alpha(BRAND.primary, 0.06),
      selected: alpha(BRAND.primary, 0.1),
      focus: alpha(BRAND.primary, 0.12),
    },
  },

  // Typography
  typography: {
    fontFamily: FONT_FAMILY,
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },

  // Component overrides
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export default theme;
